import * as React from 'react';
import {FunctionComponent, useMemo} from 'react';
import {formatDuration} from '../../Support/Formatting/formatDuration';
import {formatDistance} from '../../Support/Formatting/formatDistance';
import {formatSplit} from '../../Support/Formatting/formatSplit';
import {formatStrokeRate} from '../../Support/Formatting/formatStrokeRate';
import {format} from 'date-fns';
import {FullWorkout} from '../../../Models/FullWorkout';
import {FullWorkoutStatisticProvider} from '../../../Business/FulllWorkoutStatisticProvider';
import {WorkoutExecutionType} from '../../../Models/WorkoutExecutionType';
import {Bucket} from '../../Components/Utils/Bucket';
import {InfoTooltip} from '../../Components/Utils/InfoTooltip';
import {Link} from 'react-router-dom';
import {classNames} from '../../Support/classNames';

interface OwnProps {
    fullWorkout: FullWorkout;
    className?: string;
}

export const FullWorkoutSummary: FunctionComponent<OwnProps> = ({fullWorkout, className}) => {
    const statisticsProvider = useMemo(() => FullWorkoutStatisticProvider.create(fullWorkout), [fullWorkout]);

    if (fullWorkout.execution_type === WorkoutExecutionType.OUTDOOR) {
        return (
            <div className={classNames('card', className)}>
                <div className="card-title">
                    <h5 className="d-flex justify-content-between align-items-baseline flex-row flex-wrap">
                        <span>Workout</span>
                        <span className="fs-6">{format(fullWorkout.executed_at, 'PPpp')}</span>
                    </h5>
                </div>
                <div className="card-body">
                    <div className="row d-flex flex-column gap-2">
                        <div className="col-12 d-flex flex-row gap-2 flex-wrap">
                            <Bucket value={formatDuration(statisticsProvider.activeDuration)} label="Total time" />
                            <Bucket value={formatDistance(statisticsProvider.activeDistance)} label="Distance" />
                            <Bucket value={formatSplit(statisticsProvider.activeAverageSpeed)} label="Ø Split" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5 className="d-flex justify-content-between align-items-baseline flex-row flex-wrap">
                    <span>
                        Workout
                        <InfoTooltip className="ms-2" description="This summary only contains active intervals" />
                    </span>
                    <span className="fs-6">{format(fullWorkout.executed_at, 'PPpp')}</span>
                </h5>
            </div>
            <div className="card-body">
                <div className="row d-flex flex-column gap-2">
                    <div className="col-12 d-flex flex-row gap-2 flex-wrap">
                        <Bucket value={formatDuration(statisticsProvider.activeDuration)} label="Total time" />
                        <Bucket value={formatDistance(statisticsProvider.activeDistance)} label="Distance" />
                    </div>
                    <div className="col-12 d-flex flex-row gap-2 flex-wrap">
                        <Bucket value={formatSplit(statisticsProvider.activeAverageSpeed)} label="Ø Split" />
                        <Bucket value={formatStrokeRate(statisticsProvider.activeStokeRate)} label="Ø Stroke rate" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 d-flex justify-content-end mt-3">
                        <Link to={'/workouts/show/' + fullWorkout.id}>View</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
